import React from 'react';
import { Box, Typography } from '@mui/material';
import T from '../theme';
import { ImpactBadge, DataTable, InsightList, WhyThisMatters } from '../components/Shared.jsx';

export function CategoryThemes({ data }) {
  const { themeBreakdown = [], categoryLandscape = [], competitiveContext, themeGapsVsCategory = [], insights = [] } = data;

  return (
    <Box>
      {themeBreakdown.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.textSecondary, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>Theme Breakdown</Typography>
          {themeBreakdown.map((t, i) => (
            <Box key={i} sx={{ mb: 1, p: 1.5, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 1, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
              <Box sx={{ px: 1.25, py: 0.4, background: 'rgba(249,115,22,0.2)', color: T.primary, borderRadius: 6, fontSize: 13, fontWeight: 700 }}>{t.percentage}%</Box>
              <Typography sx={{ fontWeight: 600, fontSize: 13, color: T.text, flex: 1 }}>{t.theme}</Typography>
              <Box sx={{ px: 1, py: 0.25, background: t.categoryTrend === 'growing' ? 'rgba(34,197,94,0.15)' : t.categoryTrend === 'declining' ? 'rgba(239,68,68,0.15)' : T.surface3, color: t.categoryTrend === 'growing' ? T.success : t.categoryTrend === 'declining' ? T.error : T.textSecondary, borderRadius: 4, fontSize: 11 }}>{t.categoryTrend}</Box>
              <ImpactBadge value={t.saturation} />
            </Box>
          ))}
        </Box>
      )}

      {categoryLandscape.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.textSecondary, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>Competitive Landscape</Typography>
          <DataTable
            columns={['Show', 'Overlap', 'Category', 'Rank', 'Differentiation']}
            rows={categoryLandscape.map((c) => [c.competitorShow, `${c.themeOverlap}%`, c.category, c.rank, c.differentiation])}
          />
        </Box>
      )}

      {/* Only show Context when it contains actionable competitive info, not "no data" disclaimers */}
      {competitiveContext && !/no (category|competitor|ranking|top.?100) .*(provided|available|data)/i.test(competitiveContext) && (
        <Box sx={{ mb: 3, p: 2, background: 'rgba(45,212,191,0.07)', border: `1px solid rgba(45,212,191,0.2)`, borderRadius: 1 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.accent, textTransform: 'uppercase', mb: 0.75 }}>Context</Typography>
          <Typography sx={{ fontSize: 13, color: T.textSecondary }}>{competitiveContext}</Typography>
        </Box>
      )}

      {themeGapsVsCategory.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.warning, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1 }}>Theme Gaps vs Category</Typography>
          {themeGapsVsCategory.map((tg, i) => (
            <Box key={i} sx={{ mb: 1, p: 1.5, background: 'rgba(234,179,8,0.07)', border: `1px solid rgba(234,179,8,0.25)`, borderRadius: 1 }}>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: T.text, mb: 0.25 }}>{tg.gap}</Typography>
              <Typography sx={{ fontSize: 12, color: T.textSecondary }}>Trend: {tg.categoryTrend} · Opportunity: {tg.opportunity}</Typography>
            </Box>
          ))}
        </Box>
      )}

      <InsightList insights={insights} />
      <WhyThisMatters text="Category positioning affects chart rankings and listener discovery." citations={data.expertCitations} />
    </Box>
  );
}
